import { useTranslation } from "react-i18next";

import type { HereAndNowTab } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";
import { Loader } from "@atoms";

import { HaNContext } from "../shell/HaNContext";

const LABEL_KEY_BY_TAB = {
  rooms: "hereAndNow:LoadingRooms",
  workspaces: "hereAndNow:LoadingWorkspaces",
  facilities: "hereAndNow:LoadingFacilities",
} as const satisfies Record<HereAndNowTab, string>;

// Floats on the map under the filter bar until the tab's first data arrives. It covers nothing and takes no clicks.
export const HaNMapLoading = () => {
  const { t } = useTranslation();
  const { tab, isTabLoading } = useRequiredContext(HaNContext);

  if (!isTabLoading) return null;

  return (
    <div
      role="status"
      className="pointer-events-none absolute left-1/2 top-20 lg:top-[22px] z-10 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full bg-white px-3 py-1.5 text-sm shadow-mapiq-small">
      <Loader size="16px" />
      {t(LABEL_KEY_BY_TAB[tab])}
    </div>
  );
};
